import { Text, Badge } from '@fluentui/react-components';
import { CheckmarkCircleRegular, CircleRegular, ArrowCircleRightRegular } from '@fluentui/react-icons';
import type { MethodologyDocument } from '../services/document-service';

const PHASES = [
  { id: 'strategy', label: 'Strategy' },
  { id: 'plan', label: 'Plan' },
  { id: 'ready', label: 'Ready' },
  { id: 'adopt', label: 'Adopt' },
] as const;

interface CafPhaseTrackerProps {
  currentPhase: string;
  documents: Pick<MethodologyDocument, 'cafPhase' | 'status'>[];
}

export function CafPhaseTracker({ currentPhase, documents }: CafPhaseTrackerProps) {
  const phaseIndex = PHASES.findIndex(p => p.id === currentPhase);

  return (
    <div className="caf-tracker">
      {PHASES.map((phase, i) => {
        const phaseDocs = documents.filter(d => d.cafPhase === phase.id);
        const completed = phaseDocs.filter(d => d.status === 'final').length;
        const total = phaseDocs.length;
        const isActive = i === phaseIndex;
        const isDone = i < phaseIndex;

        return (
          <div key={phase.id} className={`caf-phase ${isActive ? 'caf-phase--active' : ''} ${isDone ? 'caf-phase--done' : ''}`}>
            <div className="caf-phase-icon">
              {isDone ? <CheckmarkCircleRegular /> : isActive ? <ArrowCircleRightRegular /> : <CircleRegular />}
            </div>
            <Text size={300} weight={isActive ? 'semibold' : 'regular'}>{phase.label}</Text>
            {total > 0 && (
              <Badge size="small" appearance="outline" color={completed === total ? 'success' : 'informative'}>
                {completed}/{total}
              </Badge>
            )}
            {i < PHASES.length - 1 && <div className="caf-connector" />}
          </div>
        );
      })}
    </div>
  );
}
